export const DEPENDENT_RELATIONSHIPS = {
  SPOUSE: "15",
  CHILD: "16",
  OTHER: "-16"
};

export const VALIDATION_CONSTRAINTS = {
  MIN_DEPENDENT_AGE_DAYS: 30,
  MAX_CHILD_AGE: 23,
  COVERAGE_DATE_RANGE: {
    MIN_DAYS_BEFORE: -15,
    MAX_DAYS_AFTER: 45
  }
};

export const MAIN_APPLICANT_FIELDS = [
  "name",
  "surname", 
  "email",
  "gender",
  "country",
  "coverage",
  "birthday"
];

export const DEPENDENT_FIELDS = [
  "name",
  "surname",
  "gender", 
  "country",
  "birthday",
  "componentId"
];

export const ERROR_TYPES = {
  EMPTY: 'empty',
  INVALID: 'invalid',
  BLANK: 'blank',
  INVALID_INPUT_SON: 'invalidInputSon',
  INVALID_INPUT_OTHER: 'invalidInputOther', 
  INVALID_INPUT_SPOUSE: 'invalidInputSpouse',
  BAD_ENTRY: 'badEntry'
};

export const AGE_LIMITS = {
  MIN_AGE: 18,
  MAX_AGE: 75
};

export const VALIDATION_STEPS = {
  STEP_2: 2,
  STEP_4: 4,
  STEP_5: 5,
  STEP_6: 6,
  STEP_8: 8,
  STEP_9: 9
};

export const BENEFIT_VALIDATION_KEYS = {
  MATERNITY_AND_CESAREAN: 'Maternity and cesarean',
  MATERNITY: 'matrnity',
  MATERNITY_NO_VALUE: 'matrnity_no',
  MATERNITY_ID_182: '182'
};
